export function isUserInventoryAdmin(inventory, userId) {
  return inventory.adminsIds.includes(userId);
}